const PLACEMENT_AUTO = 'auto';
const PLACEMENT_BOTTOM_END = 'bottom-end';
const PLACEMENT_BOTTOM_START = 'bottom-start';
export { PLACEMENT_AUTO, PLACEMENT_BOTTOM_END, PLACEMENT_BOTTOM_START };
//# sourceMappingURL=constants.js.map